var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: { title: _vm.title, width: _vm.widthDialog },
      on: { cancel: _vm.handleCancel },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("a-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取消"),
              ]),
              _c(
                "a-button",
                {
                  attrs: {
                    disabled: _vm.fileList.length === 0,
                    loading: _vm.uploading,
                    type: "primary",
                  },
                  on: { click: _vm.handleOk },
                },
                [_vm._v("\n      导入\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.isModalVisible,
        callback: function ($$v) {
          _vm.isModalVisible = $$v
        },
        expression: "isModalVisible",
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "a-form-model",
            { ref: "form", attrs: { model: _vm.model } },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "第一步：下载模版" } },
                [
                  _c("a", { attrs: { href: _vm.templateUrl } }, [
                    _vm._v(_vm._s(_vm.downloadText)),
                  ]),
                ]
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "第二步：添加文件" } },
                [
                  _c(
                    "a-upload-dragger",
                    {
                      attrs: {
                        accept: ".xls,.xlsx",
                        name: "file",
                        "file-list": _vm.fileList,
                        multiple: true,
                        action: _vm.uploadAction,
                        headers: _vm.tokenHeader,
                      },
                      on: { change: _vm.handleChange },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "ant-upload-drag-icon" },
                        [_c("a-icon", { attrs: { type: "inbox" } })],
                        1
                      ),
                      _c("p", { staticClass: "ant-upload-text" }, [
                        _vm._v("添加文件"),
                      ]),
                      _c("p", { staticClass: "ant-upload-hint" }, [
                        _vm._v("(仅支持.xls或.xlsx格式的文件)"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }